import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { FormNoticeOfIntentService } from "../../../../Services/FormNoticeOfIntentService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { IFormNoticeOfIntent } from "../../../../Models/Forms/IFormNoticeOfIntent";
import { IepService } from "../../../../Services/IepService";
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Message } from 'primeng/primeng';
import { Router } from "@angular/router";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';


@Component({
  selector: 'NoticeOfIntent',
  templateUrl: './NoticeOfIntent.component.html',
  styleUrls: ['./NoticeOfIntent.component.css']

})
export class FormNoticeOfIntentComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;  
  canEditIep: boolean;
  saveClicked: boolean;
  noticeOfIntentDB: any = [];
  reportParamArray: IReportParameter[];
  //public showSpinner: boolean = false;

  constructor(
    private globals: Globals, reportService: ReportService,
    private _formNoticeOfIntentService: FormNoticeOfIntentService,
    iepService: IepService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router) {
      super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
  }

  ngOnInit(): void {
    this.LoadFormNoticeOfIntentDetails();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  loadUnLock() {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=UnLock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  LoadFormNoticeOfIntentDetails(): void {
    this._formNoticeOfIntentService.getFormNoticeOfIntent(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormNoticeOfIntent) => {
        this.noticeOfIntentDB = res;
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  //Save the Notice Of Intent
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;

    //update values    
    this._formNoticeOfIntentService.insertUpdateFormNoticeOfIntent(this.noticeOfIntentDB)
      .subscribe((res: IFormNoticeOfIntent) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock();
        }
        this.saveClicked = false;
        this.validateForm();
        this.LoadFormNoticeOfIntentDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  validateForm() {
    this._formNoticeOfIntentService.validateForm(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: string[]) => {
        for (var item of res) {
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error', detail: item };
          this.addMessage(errorMessage);
        }
      },
        err => console.error(err)
      );
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock();
    this.LoadFormNoticeOfIntentDetails();
  }
  
  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'dtFrmEdited', parameterValue: this.noticeOfIntentDB.updatedOn.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: 'True' },
      { parameterName: 'FormInstanceID', parameterValue: this.noticeOfIntentDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'False' },
      { parameterName: 'CustomWatermarkText', parameterValue: '' },
      { parameterName: 'FormVersionID', parameterValue: '' },
      { parameterName: 'BlankForm', parameterValue: 'false' },
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.noticeOfIntentDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.noticeOfIntentDB.rdlFileNameSpanish, this.reportParamArray);
  }

}



